import { render, staticRenderFns } from "./FieldSelectorMultiple.vue?vue&type=template&id=52b06596&scoped=true&"
import script from "./FieldSelectorMultiple.vue?vue&type=script&lang=js&"
export * from "./FieldSelectorMultiple.vue?vue&type=script&lang=js&"
import style0 from "./FieldSelectorMultiple.vue?vue&type=style&index=0&id=52b06596&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b06596",
  null
  
)

export default component.exports